export const homeObjOne = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "PREMIUM BANK",
  headline: "Unlimited transaction with zero fees",
  description:
    "Get access to our exclusive app that allows you to send unlimited transactions without getting charged any fees",
  buttonLabel: "Get Started",
  imgStart: false,
  img: require("../../images/svg-1.png"),
  alt: "Car",
  dark: true,
  primary: true,
  darkText: false,
};

export const homeObjTwo = {
  id: "discover",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "UNLIMITED ACCESS",
  headline: "Login to your account at any time",
  description:
    "We have you covered no matter where you are located. All you need is an internet connection and a phone or computer.",
  buttonLabel: "Get Started",
  imgStart: true,
  img: require("../../images/svg-6.png"),
  alt: "Car",
  dark: true,
  primary: true,
  darkText: true,
};

export const homeObjThree = {
  id: "signup",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "JOIN OUR TEAM",
  headline: "Creating an account is extremely easy",
  description:
    "Get everything set and ready in under 10 minutes. All you need to do is add your information and you're ready to go",
  buttonLabel: "Get Started",
  imgStart: false,
  img: require("../../images/svg-4.png"),
  alt: "Car",
  dark: true,
  primary: true,
  darkText: true,
  dark2: true,
};
